export const MY_ALERTS_STARTED = 'MY_ALERTS_STARTED';
export const MY_ALERTS_SUCCESS = 'MY_ALERTS_SUCCESS';
export const MY_ALERTS_FAILURE = 'MY_ALERTS_FAILURE';

export const REMOVE_FROM_ALERTS_STARTED = 'REMOVE_FROM_ALERTS_STARTED';
export const REMOVE_FROM_ALERTS_SUCCESS = 'REMOVE_FROM_ALERTS_SUCCESS';
export const REMOVE_FROM_ALERTS_FAILURE = 'REMOVE_FROM_ALERTS_FAILURE';